export default "__VITE_ASSET__$Yk7tiRS__"